import loadable from 'loadable-components'

export default {
	Phishing: { exact: true, path: '/demo/phishing', component: loadable(() => import('./Phishing')) },
    UserDashboard: { exact: true, path: '/org/:org_id/:token', component: loadable(() => import('./UserDashboard')) },
    Administration: { exact: true, path: '/admin/:token', component: loadable(() => import('./Administration')) },
    Login: { exact: true, path: '/', component: loadable(() => import('./Login')) }
}
